import { defineStore } from 'pinia'

export const useProductStore = defineStore('product', {
	state: () => {
		return {
			products: [],
		}
	},
	actions: {
		setup() {
			this.getProducts()
		},
		getProducts() {
			return axios
				.get('/api/product')
				.then((products) => {
					this.products = products.data
				})
				.catch((error) => {
					console.error(error)
				})
		},
	},
})
